import { render, staticRenderFns } from "./physicalImage.vue?vue&type=template&id=30318bc0&scoped=true&"
import script from "./physicalImage.vue?vue&type=script&lang=js&"
export * from "./physicalImage.vue?vue&type=script&lang=js&"
import style0 from "./physicalImage.vue?vue&type=style&index=0&id=30318bc0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30318bc0",
  null
  
)

export default component.exports